import React, { useState, useEffect } from "react";
import { RouteComponentProps } from "react-router-dom";

import { V1 } from "../../Api";
import { COPY_YEAR } from '../../Const';

import HCWHLogoWhite from "../../images/hcwh_logo_white_small_notext.png";
import TWCLogo from "../../images/twc_white.png";

import "../../css/form.css";
import "../../css/list.css";
import "../../css/checkbox.css";

function UnsubscribePage(props: RouteComponentProps<any>) {
    const [allowOptOut, updateAllowOptOut] = useState(false);
    const [isSubmitting, updateIsSubmitting] = useState<string | boolean>(false);

    useEffect(() => { document.title = "UOG Paperless Opt-out" }, []);

    async function submitOptOut() {
        try {
            updateIsSubmitting(true);
            await V1.post(`unsubscribe/${props.match.params.unsubId}`);
            updateIsSubmitting(false);

            props.history.replace("/unsubscribe/success");
        }
        catch (e) {
            if (e.statusCode === 404) {
                // Already opted out?
                updateIsSubmitting("It appears you've already opted out.  If this is not correct please give us a call and we'll do our best to figure out what's wrong.");
            }
            else {
                updateIsSubmitting((e.message || "Could not submit") + ". Please try again later");
            }
        }
    }

    return <>
        <header>
            <img src={HCWHLogoWhite} alt="Howard Center Logo" />
            <img src={TWCLogo} alt="Tifton Woman's Center Logo" />
        </header>
        <div className="form-root">
            <h1 className="no-top-margin">Paperless Opt-out</h1>
            <p>
                We are glad to continue to send you paper statements, but we respectfully ask
                you to consider the benefits:
            </p>
            <p>
                Paperless is both fast and convenient and it allows you to pay your bill online easily with your
                credit card or other services you already use.
            </p>
            <p>
                If you still want to opt-out from paperless statements from United Obstetrics and Gynecology,
                please check the box below and press the Opt Out button.
            </p>
            <div className="input-group">
                <span className="checkbox">
                    <input type="checkbox" id="agree-checkbox"
                        checked={allowOptOut}
                        onChange={e => { updateAllowOptOut(e.currentTarget.checked); }} />
                    <label htmlFor="agree-checkbox">
                        By checking this box, you confirm that you wish not to receive your statements by email,
                        and instead have them mailed to you.
                    </label>
                </span>
            </div>
            <p>
                <button type="button" className="button" disabled={!allowOptOut || isSubmitting === true} onClick={submitOptOut}>Opt Out</button>
            </p>
            <p>
                <small>
                    If you later decide that you want to receive your statements by email again,
                    please give us a call at <a href="tel:12293913500">(229) 391-3500</a>.
                </small>
            </p>
            {
                isSubmitting === true
                    ? <p>Submitting, please wait...</p>
                    : typeof isSubmitting === "string"
                        ? <div className="error-box slim">{isSubmitting}</div>
                        : null
            }
        </div>
        <footer className="footer-version">
            <small>&copy; {COPY_YEAR} United Obstetrics and Gynecology</small>
        </footer>
    </>;
};

export function UnsubscribeCompletePage(props: RouteComponentProps<any>) {
    useEffect(() => { document.title = "UOG Paperless Opt-out Complete" }, []);

    return <>
        <header>
            <img src={HCWHLogoWhite} alt="Howard Center Logo" />
            <img src={TWCLogo} alt="Tifton Woman's Center Logo" />
        </header>
        <div className="form-root">
            <h1 className="no-top-margin">Paperless Opt-out</h1>
            <p>
                You've successfully opted out of paperless statements.  If you have further questions,
                please call us at <a href="tel:12293913500">(229) 391-3500</a>.
            </p>
            <p>
                You may now close this page.
            </p>
        </div>
        <footer className="footer-version">
            <small>&copy; {COPY_YEAR} United Obstetrics and Gynecology</small>
        </footer>
    </>;
};

export default UnsubscribePage;
